import api, { TOKEN_STORAGE_KEY } from "./client";

const buildStreamUrl = () => {
  const baseUrl = api.defaults?.baseURL || "/api";
  const normalized = baseUrl.startsWith("http")
    ? baseUrl
    : baseUrl.startsWith("/")
      ? baseUrl
      : `/${baseUrl}`;

  return `${normalized.replace(/\/?$/, "")}/status/stream`;
};

export const subscribeToActiveUnitStream = ({ onMessage, onError, onOpen } = {}) => {
  if (typeof EventSource === "undefined") {
    return null;
  }

  const token = localStorage.getItem(TOKEN_STORAGE_KEY);
  if (!token) return null;
  const url = new URL(buildStreamUrl(), window.location.origin);
  url.searchParams.set("hintsOnly", "true");

  if (token) {
    url.searchParams.set("access_token", token);
  }

  const eventSource = new EventSource(url.toString(), { withCredentials: false });

  const currentSession = () => {
    if (localStorage.getItem(TOKEN_STORAGE_KEY) === token) return true;
    eventSource.close();
    if (typeof onError === "function") onError({ type: "session-changed" });
    return false;
  };
  eventSource.addEventListener("open", event => {
    if (currentSession() && typeof onOpen === "function") onOpen(event);
  });

  eventSource.addEventListener("message", (event) => {
    if (!currentSession()) return;
    if (typeof onMessage !== "function") {
      return;
    }

    try {
      const payload = JSON.parse(event.data);
      onMessage(payload);
    } catch (error) {
      console.warn("Unable to parse active unit stream payload", error);
    }
  });

  eventSource.addEventListener("error", (event) => {
    // The dashboard reconnects using current credentials. Native EventSource
    // retries would keep reusing the URL's expired/revoked token.
    eventSource.close();
    if (typeof onError === "function") {
      onError(event);
    }
  });

  return eventSource;
};
